const KEY = "gc_cart";

export function getCart() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(c) ? c : [];
  } catch {
    return [];
  }
}

function save(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("cart-updated"));
  return items;
}

export function addToCart(item) {
  const cart = getCart();
  const existing = cart.find(
    (c) =>
      c.speciality === item.speciality &&
      c.variant === item.variant &&
      c.roast === item.roast &&
      c.grind === item.grind &&
      c.size === item.size &&
      c.blend_arabica_pct === item.blend_arabica_pct
  );
  if (existing) existing.bags = Math.min((existing.bags || 1) + 1, 50);
  else cart.push({ ...item, bags: 1, line_id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}` });
  return save(cart);
}

export function setBags(lineId, bags) {
  const cart = getCart().map((c) => (c.line_id === lineId ? { ...c, bags: Math.max(1, Math.min(bags, 50)) } : c));
  return save(cart);
}

export function removeFromCart(lineId) {
  return save(getCart().filter((c) => c.line_id !== lineId));
}

export function clearCart() {
  return save([]);
}
